module.exports = __webpack_public_path__ + "img/ledger-live-setting-step-eleven.5f49fb25.png";